const SERVICE_ACTION_TYPE = {
  GET_SERVICES: 'GET_SERVICES',
  GET_SERVICE: 'GET_SERVICE',
  CREATE_SERVICE: 'CREATE_SERVICE',
  UPDATE_SERVICE: 'UPDATE_SERVICE',
  CREATE_COMMUNICATION: 'CREATE_COMMUNICATION',
  UPDATE_COMMUNICATION: 'UPDATE_COMMUNICATION',
  DELETE_COMMUNICATION: 'DELETE_COMMUNICATION'
}
export default SERVICE_ACTION_TYPE
